import { useEffect } from "react";
import styled from "styled-components";
import { Routes, Route, useLocation } from "react-router-dom";

import { LightProvider, useLight } from "./context/LightContext";
import Nav, { BRAND } from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./routes/Home";
import Product from "./routes/Product";

export default function App() {
  return (
    <LightProvider>
      <Shell />
    </LightProvider>
  );
}

function Shell() {
  const { ready, progress } = useLight();
  const { pathname } = useLocation();

  /* jump to top on route change */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!ready) {
    return (
      <Loader>
        <LoaderMark>{BRAND}</LoaderMark>
        <Bar>
          <Fill style={{ transform: `scaleX(${progress})` }} />
        </Bar>
      </Loader>
    );
  }

  return (
    <Page>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/produkti/:id" element={<Product />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </Page>
  );
}

const Page = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Loader = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  background: var(--bg);
`;

const LoaderMark = styled.div`
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 30px;
`;

const Bar = styled.div`
  width: min(180px, 46vw);
  height: 1px;
  background: var(--line);
`;

const Fill = styled.div`
  height: 100%;
  background: var(--ink);
  transform-origin: left;
  transition: transform 200ms linear;
`;
